export default "__VITE_ASSET__BDOKomA0__"